import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "company_container" }
const _hoisted_2 = { class: "company_title" }
const _hoisted_3 = { class: "company_content" }
const _hoisted_4 = { class: "company_content_box" }
const _hoisted_5 = { style: {"width":"1300px","height":"630px"} }
const _hoisted_6 = ["data"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "company_scroll_box" }
const _hoisted_9 = { class: "fw_box" }
const _hoisted_10 = { class: "bxslider" }
const _hoisted_11 = { class: "company_scroll_list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  class: "tanchu",
  style: {"display":"block"}
}
const _hoisted_16 = { class: "tc_bj" }
const _hoisted_17 = { style: {"padding":"30px","overflow":"hidden"} }

import {onBeforeMount, reactive, ref} from 'vue';
import {Swiper, SwiperSlide} from 'swiper/vue/swiper-vue';
import 'swiper/swiper.css';
import SwiperCore, {Autoplay, Grid, Pagination, EffectCoverflow, Navigation} from "swiper";
import { simpleOneThing } from "@/config/request";
import {useRoute} from "vue-router";
import {IMAGE_PREVIEW} from "@/config/const";
import {neverNull} from '@/utils/util'

export default /*@__PURE__*/_defineComponent({
  __name: 'detail',
  setup(__props) {

SwiperCore.use([Autoplay, Grid, Pagination, EffectCoverflow, Navigation]);
// swiper相关配置属性放在swiper_options这个变量里
let swiper_options = reactive({
  autoplay: true,
  slidesPerView: 4,
  centeredSlides: false,  // true为居中
  spaceBetween: 45,  // 元素间距
  loop: true,
  observer: true,
  observeParents: true,
  speed: 300,
  loopedSlides: 30,
  slidesPerGroup: 1,
  paginationClickable: true,
  grid: {rows: 1, fill: 'row'},
  pagination: {
    el: '.swiper-pagination'
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});
const isShow = ref(false);
const toWorkGuide = (item: any) => {
  window.open(item.webSiteUrl)
}
const clickService = ref({})
const openModal = (serviceInfo: any) => {
  isShow.value = true;
  clickService.value = serviceInfo;
}
const closeDialog = () => {
  isShow.value = false;
}
const serviceList = ref([]);
const route = useRoute()
const query = route.query
const flowUrl = ref('')
const getServiceList = async () => {
  const param = {
    onethingName: query.oneThingName,
  }
  const res = await simpleOneThing(param) as any
  serviceList.value = res?.result
  flowUrl.value = IMAGE_PREVIEW + query.flowUrl
}
onBeforeMount(async () => {
  await getServiceList();
})


return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[10] || (_cache[10] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _createElementVNode("span", null, [
          _cache[0] || (_cache[0] = _createElementVNode("img", { src: "/images/company_title.png" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_unref(query).oneThingName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "company_title2" }, "流程图", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("object", {
              data: flowUrl.value + '#zoom=90&scrollbar=0&toolbar=0&navpanes=0',
              width: "100%",
              height: "100%",
              type: "application/pdf"
            }, [
              _createElementVNode("p", null, [
                _cache[1] || (_cache[1] = _createTextVNode("您的浏览器不支持查看PDF文件，请下载", -1)),
                _createElementVNode("a", {
                  href: flowUrl.value,
                  style: {"text-decoration":"underline","color":"#3A7FB3FF"}
                }, "PDF", 8, _hoisted_7),
                _cache[2] || (_cache[2] = _createTextVNode("查看 ", -1))
              ])
            ], 8, _hoisted_6)
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "company_title2" }, "事项办理", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("div", {
              class: "swiper-button-prev",
              style: {"top":"1200px"}
            }, [
              _createElementVNode("svg", {
                t: "1641887663985",
                class: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "p-id": "6681",
                width: "50",
                height: "50"
              }, [
                _createElementVNode("path", {
                  d: "M512 149.333333c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666667S149.333333 712.298667\r\n                      149.333333 512 311.701333 149.333333 512 149.333333z m42.666667 168.085334L360.085333 512 554.666667 706.581333 599.914667\r\n                      661.333333l-149.333334-149.333333 149.333334-149.333333L554.666667 317.418667z",
                  "p-id": "6682",
                  fill: "#ddd"
                })
              ])
            ], -1)),
            _cache[4] || (_cache[4] = _createElementVNode("div", {
              class: "swiper-button-next",
              style: {"top":"1200px"}
            }, [
              _createElementVNode("svg", {
                t: "1641887663985",
                class: "icon",
                viewBox: "0 0 1024 1024",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "p-id": "6681",
                width: "50",
                height: "50"
              }, [
                _createElementVNode("path", {
                  d: "M512 149.333333c200.298667 0 362.666667 162.368 362.666667 362.666667s-162.368 362.666667-362.666667 362.666667S149.333333 712.298667\r\n                      149.333333 512 311.701333 149.333333 512 149.333333z m42.666667 168.085334L360.085333 512 554.666667 706.581333 599.914667\r\n                      661.333333l-149.333334-149.333333 149.333334-149.333333L554.666667 317.418667z",
                  "p-id": "6682",
                  fill: "#ddd"
                })
              ])
            ], -1)),
            _createVNode(_unref(Swiper), {
              pagination: _unref(swiper_options).pagination,
              loop: _unref(swiper_options).loop,
              navigation: _unref(swiper_options).navigation,
              spaceBetween: _unref(swiper_options).spaceBetween,
              centeredSlides: _unref(swiper_options).centeredSlides,
              slidesPerView: _unref(swiper_options).slidesPerView,
              slidesPerGroup: _unref(swiper_options).slidesPerGroup
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serviceList.value, (item, idx) => {
                  return (_openBlock(), _createBlock(_unref(SwiperSlide), null, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", _hoisted_10, [
                        _createElementVNode("li", _hoisted_11, [
                          _createElementVNode("p", null, _toDisplayString(item.serviceName), 1),
                          _createElementVNode("p", null, [
                            _createElementVNode("small", null, _toDisplayString(item.deptName), 1)
                          ]),
                          (_unref(neverNull)(item.webSiteUrl).length > 0)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (toWorkGuide(item))
                              }, "去办理", 8, _hoisted_12))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: ($event: any) => (openModal(item))
                              }, "去办理", 8, _hoisted_13)),
                          _createElementVNode("img", {
                            src: '/images/company'+(Number(idx%6)+Number(1))+'.png'
                          }, null, 8, _hoisted_14)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 256))
              ]),
              _: 1
            }, 8, ["pagination", "loop", "navigation", "spaceBetween", "centeredSlides", "slidesPerView", "slidesPerGroup"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom),
    (isShow.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", null, [
                _createElementVNode("a", { onClick: closeDialog }),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "t2_zt1" }, null, -1)),
                _cache[8] || (_cache[8] = _createTextVNode("办理地址 ", -1))
              ]),
              _createElementVNode("div", _hoisted_17, _toDisplayString(clickService.value.modalMsg), 1)
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("div", {
            class: "mask",
            id: "mask",
            style: {"display":"block"}
          }, null, -1))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})